import { dispatch } from "@rematch/core";
import { CQ } from "utils/commonQuest";
import { getTradeSource, getTradingStatus } from "utils/interface";

// 贸易状态
export const tradingStatus = {
  state: {},
  effects: {
    async getTradeSource(payload: any, rootState: any) {
      //const data = await _GET(APIS.getTradeSource);
      const data = await CQ(getTradeSource());
      dispatch["share"].updateTradeSource(data);
    },
    async getTradingStatus(payload: any, rootState: any) {
      const data = await CQ(getTradingStatus());
      dispatch["share"].updateTradingStatus(data);
    }
  }
};
